import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Briefcase, MapPin, Calendar, Banknote } from "lucide-react";
import SEO from "@/components/SEO";

const FILTERS = [
    { key: "all", label_bn: "সকল", label_en: "All" },
    { key: "govt", label_bn: "সরকারি", label_en: "Government" },
    { key: "bank", label_bn: "ব্যাংক", label_en: "Bank" },
    { key: "private", label_bn: "প্রাইভেট", label_en: "Private" },
    { key: "ngo", label_bn: "এনজিও", label_en: "NGO" },
];

export default function JobCirculars() {
    const { t, lang } = useI18n();
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        const url = filter === "all" ? "/job-circulars" : `/job-circulars?category=${filter}`;
        api.get(url).then((r) => setItems(r.data));
    }, [filter]);

    return (
        <div>
            <SEO title={t("circular_title")} description={lang === "bn" ? "সর্বশেষ চাকরির বিজ্ঞপ্তি ও নিয়োগ সংবাদ" : "Latest job announcements and recruitment news"} />
            <section className="bg-hero-grad py-12 md:py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-xs font-semibold tracking-wider text-brand-red">CAREERS</div>
                    <h1 className="text-4xl sm:text-5xl font-bold text-brand-navy mt-2">{t("circular_title")}</h1>
                    <p className="text-brand-navy/65 mt-2 max-w-2xl">{lang === "bn" ? "সর্বশেষ চাকরির বিজ্ঞপ্তি ও নিয়োগ সংবাদ" : "Latest job announcements and recruitment news"}</p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="flex flex-wrap gap-2 mb-6">
                    {FILTERS.map((f) => (
                        <button key={f.key} onClick={() => setFilter(f.key)}
                            className={`px-4 py-2 rounded-full text-sm font-medium transition ${filter === f.key ? "btn-primary" : "border border-brand-light text-brand-navy hover:bg-brand-light/40"}`}>
                            {lang === "bn" ? f.label_bn : f.label_en}
                        </button>
                    ))}
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    {items.map((j) => (
                        <Link key={j.id} to={`/job-circulars/${j.id}`} className="block bg-white border border-brand-light rounded-2xl p-6 hover:border-brand-royal hover:shadow-soft transition group">
                            <div className="flex items-start gap-4">
                                <div className="w-14 h-14 rounded-xl btn-primary grid place-items-center text-white shadow-pop flex-shrink-0">
                                    <Briefcase className="w-6 h-6" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="text-[10px] font-bold tracking-wider text-brand-red uppercase">{j.category}</div>
                                    <h3 className="text-lg font-bold text-brand-navy mt-1 group-hover:text-brand-royal">{j.title}</h3>
                                    <div className="text-sm text-brand-navy/65 mt-1">{j.organization}</div>
                                    <div className="grid grid-cols-2 gap-2 mt-4 text-xs text-brand-navy/70">
                                        <span className="inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-brand-royal" /> {j.deadline}</span>
                                        <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-brand-royal" /> {j.location}</span>
                                        <span className="inline-flex items-center gap-1.5 text-brand-red font-semibold">পদ: {j.vacancy}</span>
                                        <span className="inline-flex items-center gap-1.5"><Banknote className="w-3.5 h-3.5 text-brand-royal" /> {j.salary}</span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
